import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=6b6ce4e4&scoped=true&"
import script from "./SearchForm.vue?vue&type=script&lang=js&"
export * from "./SearchForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SearchForm.vue?vue&type=style&index=1&id=6b6ce4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ce4e4",
  null
  
)

export default component.exports